import React from "react";
import { Icon } from "@/components/Icon";

export type ProductOfferingProps = {
  title: string;
  highlight: string;
  description: string;
  offerings: { icon?: React.JSX.Element; title: string; description: string }[];
};

export default function ProductOfferingSection({
  title,
  description,
  offerings,
  highlight,
}: ProductOfferingProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="md:py-12 md:px-8 py-6 px-4 rounded-lg bg-gradient-to-br from-purple-200 mix-blend-overlay via-[#fcfcfc]  to-[#f3d6d6] flex flex-col items-center gap-4 md:gap-8 mx-4">
      <div className="flex flex-col text-center justify-center items-center mb-4 w-full gap-4 md:w-4/5">
        <h2 className="md:text-[45px] text-2xl text-secondary-900 font-bold leading-tight">
          {before}
          <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
            {highlight}
          </span>
          {after}
        </h2>
        <span className="text-center md:text-xl text-base">{description}</span>
      </div>
      <div className="grid md:grid-cols-3 grid-cols-1 gap-8 min-h-[140px] pb-8">
        {offerings.map((offering) => {
          return (
            <div
              className="p-4 flex gap-6 border border-gray-300 rounded-lg bg-[#FAFAFA]"
              key={offering.title}
            >
              <div className="w-full max-w-[40px] block md:hidden lg:block">
                {offering.icon}
              </div>

              <div className="flex flex-col gap-4 text-start md:text-center lg:text-start">
                <div className="w-full md:flex lg:hidden hidden items-center justify-center">
                  {offering.icon}
                </div>
                <span className="md:text-2xl text-xl text-secondary-900 font-semibold md:min-h-[60px]">
                  {offering.title}
                </span>
                <span className="text-base md:text-lg text-secondary-900 ">
                  {offering.description}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
